import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';
import root from 'window-or-global';

export default class Header extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
      richTextResolver: item => `<object text="${item.text}" 
                                         size="${item.size}" 
                                         color="${item.color}"
                                         htmlModifiers="${item.htmlModifiers}"
                                         constructor="${item.type}"/>`,
    });
  }

  get type() {
    return get(this, 'system.type', '');
  }

  get text() {
    return get(this, '_text.value', '');
  }

  get size() {
    return get(this, '_size.value[0].name', '');
  }

  get color() {
    return get(this, '_color.value[0].name', '');
  }

  get htmlModifiers() {
    const modifiers = get(this, '_html_modifiers', []).map(modifier => ({
      property: modifier.property,
      value: modifier.value,
    }));
    const modifiersBaseEncoded = root.btoa(JSON.stringify(modifiers));
    return modifiersBaseEncoded;
  }
}



// WEBPACK FOOTER //
// ./src/models/Header.model.js